import { useAuth } from '@/shared/auth/AuthContext';
import { CuidadorMain } from '@/roles/cuidador/CuidadorMain';

export function OperationalTab() {
  const { centerId } = useAuth();
  return (
    <div className="h-[calc(100vh-7rem)] -m-4 md:-m-6 p-3 md:p-4">
      <CuidadorMain centerId={centerId} />
    </div>
  );
}
